import { Color } from 'presentation/theme/colorScheme';

const textTheme = {
  baseStyle: {
    color: Color.OnSurface,
  },
};

export default textTheme;
